import { object, number, string, array, boolean } from '@gogame/schemas';

import {
  DEEP_LINK_END_DATE,
  DEEP_LINK_LOCATION_IN_GAME,
  DEEP_LINK_PLATFORM_TOKENS,
  DEEP_LINK_REWARD_PACKAGES,
  DEEP_LINK_SUB_LOCATION,
  DEEP_LINK_PLATFORM,
  DEEP_LINK_MULTI_REDEMPTIONS,
  DEEP_LINK_MAX_REDEMPTIONS,
} from './constants';

export const isEmptyDeepLink = (deepLink) =>
  deepLink ? !deepLink[DEEP_LINK_PLATFORM_TOKENS]?.length : true;

export const deepLinkSchema = object({
  [DEEP_LINK_REWARD_PACKAGES]: array(string().nullable()),
  [DEEP_LINK_LOCATION_IN_GAME]: number().required(
    'Location in game is required'
  ),
  [DEEP_LINK_SUB_LOCATION]: number(),
  [DEEP_LINK_END_DATE]: string().required('End date is required'),
  [DEEP_LINK_MULTI_REDEMPTIONS]: boolean(),
  [DEEP_LINK_MAX_REDEMPTIONS]: number(),
});

export const platformTokenSchema = object({
  [DEEP_LINK_PLATFORM]: number(),
});

export function creatDeepLink() {
  return deepLinkSchema.cast({}, { context: {} });
}
